// src/taskpane/components/LanguageSelector.tsx
import * as React from "react";
import { SUPPORTED_LANGUAGES, AUTO_DETECT_LANGUAGE } from "../services/types";

interface LanguageSelectorProps {
  sourceLang: string;
  targetLang: string;
  onSourceChange: (code: string) => void;
  onTargetChange: (code: string) => void;
  disabled?: boolean;
}

const selectStyle: React.CSSProperties = {
  width: "100%",
  padding: "6px 10px",
  borderRadius: "4px",
  border: "1px solid #ccc",
  fontSize: "14px",
  backgroundColor: "#fff",
  cursor: "pointer",
};

const labelStyle: React.CSSProperties = {
  display: "block",
  fontSize: "14px",
  fontWeight: 600,
  marginBottom: "4px",
};

const rowStyle: React.CSSProperties = {
  display: "flex",
  gap: "12px",
};

const fieldStyle: React.CSSProperties = {
  flex: 1,
};

export default function LanguageSelector({
  sourceLang,
  targetLang,
  onSourceChange,
  onTargetChange,
  disabled,
}: LanguageSelectorProps) {
  const allSourceLanguages = [AUTO_DETECT_LANGUAGE, ...SUPPORTED_LANGUAGES];

  return (
    <div style={rowStyle}>
      <div style={fieldStyle}>
        <label style={labelStyle}>源语言</label>
        <select
          style={selectStyle}
          value={sourceLang}
          onChange={(e) => onSourceChange(e.target.value)}
          disabled={disabled}
        >
          {allSourceLanguages.map((lang) => (
            <option key={lang.code} value={lang.code}>
              {lang.name}
            </option>
          ))}
        </select>
      </div>
      <div style={fieldStyle}>
        <label style={labelStyle}>目标语言 *</label>
        <select
          style={selectStyle}
          value={targetLang}
          onChange={(e) => onTargetChange(e.target.value)}
          disabled={disabled}
        >
          {SUPPORTED_LANGUAGES.map((lang) => (
            <option key={lang.code} value={lang.code}>
              {lang.nativeName} ({lang.name})
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
